import UserModel from "@/models/UserModel";

export default class UserDateModel {
  User: UserModel;
  Date: Date;

  constructor(data: Partial<UserDateModel>) {
    Object.assign(this, data);
  }
}
